import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  token: string | null;
  loggedInUser: string;
  identity?: any;
  email: string;
}

const initialToken = localStorage.getItem('userToken');

const initialState: AuthState = {
  token: initialToken,
  loggedInUser: '',
  identity: undefined,
  email: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    clearUserToken: state => {
      state.token = null;
    },
    setGlobalIdentity: (state, action: PayloadAction<any>) => {
      state.identity = action.payload;
    },
    setLoggedInUser: (state, action: PayloadAction<any>) => {
      state.loggedInUser = action.payload;
    },
    setLoggedInUserEmail: (state, action: PayloadAction<any>) => {
      state.email = action.payload;
    },
  },
});

export const {
  setUserToken,
  clearUserToken,
  setGlobalIdentity,
  setLoggedInUser,
  setLoggedInUserEmail,
} = authSlice.actions;
export default authSlice.reducer;
